import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { Sidebar } from "../../common/AppSidebar";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import styles from "./styles.module.css";

export const AssistantPage = () => {
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("assistants");
  const { handleSelectObject } = useStorageObject(
    "assistants",
    "assistants",
    currentService,
  );
  const { handleOpenModal } = useAppModals();

  useServiceNavigate("assistants", "assistants");

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onAdd={() =>
          handleOpenModal(
            "object_manager",
            { id: "", value: "child" },
            "create_object",
          )
        }
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"assistants"}
        isLoading={isLoading ?? false}
      />
      {selectedObject && <SafeOutlet />}
    </div>
  );
};
